// navigationCMS.ts
import { baseURL } from './baseUrl'; // Your baseURL config

// Types
export interface NavTreeNode {
  id: string;
  category_id?: string;
  category_name: string;
  category_type: string;
  is_published: boolean;
  position_order: number | null;
  item_group?: string;
  application?: string;
  application_type?: string;
  brand?: string;
  collection?: string;
  children?: NavTreeNode[];
  level: number;
  created_at: string;
  updated_at: string;

  // Nav add-on specific fields
  display_name?: string;
  is_active?: boolean;
  consumer_use_switch?: string; // "on" or "off"
  consumer_link_url?: string | null;
  consumer_link_category_id?: string | null;
  consumer_tile_display_switch?: boolean;
  consumer_tile_hover_animation_switch?: boolean;
  consumer_tile_media_single?: string | null;
  consumer_tile_media_single_url?: string | null;
  trade_use_switch?: string; // "on" or "off"
  trade_link_url?: string | null;
  trade_link_category_id?: string | null;
  trade_tile_display_switch?: boolean;
  trade_tile_hover_animation_switch?: boolean;
  trade_tile_media_single?: string | null;
  trade_tile_media_single_url?: string | null;
}

export interface NavTreeResponse {
  code: number;
  msg: string;
  success: boolean;
  nav_tree: NavTreeNode;
}

// Fetch navigation tree from CMS (no auth required)
export const fetchNavigationTree = async (): Promise<NavTreeNode[]> => {
  try {
    const response = await baseURL.post('/cms-category/category-tree', {
      include_collections: false,
      only_published: true,
      max_depth: 3
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data: NavTreeResponse = response.data;

    if (!data.success || !data.nav_tree?.children) {
      console.warn('No navigation tree data found');
      return [];
    }

    return data.nav_tree.children.filter(child => child.is_published);

  } catch (error) {
    console.error('❌ Failed to fetch navigation tree:', error);
    return [];
  }
};